<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-12-26 10:18:59
 * @LastEditors: whaoo
 * @LastEditTime: 2024-06-12 10:55:54
-->
<template>
  <div >
    <!-- <div class="search_box">
            <el-button type="warning" size="large" @click="pageTo">切换到护理报告模式</el-button>
            <div class="logo_box">
                <el-button v-show="ele_total!=0" class="ele_btn" type="danger" size="large" @click="openEleList">低电量提醒 <span class="num">{{
                    ele_total }}</span></el-button>
                <img src="../../assets/logo_2.png">
            </div>
    </div>-->

    <div class="container_box flex_box" v-if="!nodata">
      <div class="flex_item" v-for="(item, index) in dataList" :key="index">
        <div class="box_title" :style="{ 'line-height': lh }">
          <span style="margin-right: 10px;">{{ item.bed_number }}床</span>
          <span style="margin-right: 10px;">{{ item.name }}</span>
          <span>{{ item.patient_id }}</span>
        </div>
        <div class="data_box" :style="{ height: `calc(100% - ${lh})` }">
          <div class="left">
            <div class="hr_data border_bottom">
              <div class="type_title">
                <img src="../../assets/hr.png" alt />
                <span>HR</span>
              </div>
              <div class="value" v-if="detailData[item.ccid]">
                {{ detailData[item.ccid].heartrate ? detailData[item.ccid].heartrate : '--' }}
                <span class="unit">bpm</span>
              </div>
              <div class="value" v-else>
                --
                <span class="unit">bpm</span>
              </div>
            </div>
            <div class="spo2_data">
              <div class="type_title">
                <img src="../../assets/spo2.png" alt />
                <span>SpO2</span>
              </div>
              <div class="value" v-if="detailData[item.ccid]">
                {{ detailData[item.ccid].spo2 ? detailData[item.ccid].spo2 : '--' }}
                <span class="unit">%</span>
              </div>
              <div class="value" v-else>
                --
                <span class="unit">%</span>
              </div>
            </div>
          </div>
          <div class="right">
            <div :id="`chart${(index + 1) * 2 - 1}`" style=" width: 100%; height: 50%;"></div>
            <div :id="`chart${(index + 1) * 2}`" style=" width: 100%; height: 50%;"></div>
          </div>
        </div>

        <!-- <div class="hr_box flex_box mb_20">
                    <div class="left">
                        <img src="../../assets/hr_bg.png">
                        <div class="hr_value">
                            {{ item.lastData.heartrate ? item.lastData.heartrate : '--' }}<span class="unit">bpm</span>
                        </div>
                    </div>
                    <div class="right" :id="`chart${(index + 1) * 2 - 1}`">

                    </div>
                </div>
                <div class="spo2_box flex_box">
                    <div class="left">
                        <img src="../../assets/spo2_bg.png">
                        <div class="spo2_value">
                            {{ item.lastData.spo2 ? item.lastData.spo2 : '--' }}<span class="unit">%</span>
                        </div>
                    </div>
                    <div class="right" :id="`chart${(index + 1) * 2}`">

                    </div>
        </div>-->
      </div>
    </div>

    <div v-else class="nodata">
      <img src="../../assets/nodata.png" alt />
    </div>

    <el-dialog :visible.sync="ele_dialog" title="低电量提醒" width="900px">
      <div class="dialog_tips">请及时进行设备充电！</div>
      <el-table
        v-loading="dialogTableLoading"
        :key="tableKey"
        :data="dialogTableData"
        style="width: 100%; margin-bottom: 20px"
        border
        height="334px"
      >
        <el-table-column align="center" prop="ccid" label="设备CCID" width="200px"></el-table-column>
        <el-table-column align="center" prop="bed_number" label="床号"></el-table-column>
        <el-table-column align="center" prop="name" label="姓名"></el-table-column>
        <el-table-column align="center" prop="bat" label="电量">
          <template slot-scope="scope">
            <div style="color:red;">{{ scope.row.bat }}%</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="insert_time" label="电量同步时间" width="180px">
          <template slot-scope="scope">
            {{ scope.row.insert_time ? $dateFtt.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(scope.row.insert_time *
            1000))
            : '' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              class="table_btn_primary"
              @click="editBatStatus(scope.row, scope.$index)"
              size="small"
              v-show="scope.row.status !== 1"
            >处理</el-button>
            <el-button
              type="default"
              class="table_btn_primary"
              disabled
              size="small"
              v-show="scope.row.status == 1"
            >已处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="handleCurrentChange"
        :page-sizes="[5]"
        :current-page="page"
        :page-size="5"
        layout="sizes,prev, pager, next,total"
        :total="total"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nodata: true,
      dataList: [],
      hrOptions: {
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            color: "#23FA00",
          },
          axisLine: {
            lineStyle: {
              color: "#23FA0000",
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
            interval: 0,
            lineStyle: {
              color: "#23FA00AA",
            },
          },
        },
        yAxis: {
          type: "value",
          // name: "bpm",
          nameTextStyle: {
            color: "#23FA00",
            padding: [0, 0, -5, -40], //控制y轴标题位置
          },
          axisLabel: {
            color: "#23FA00",
            showMaxLabel:true,
            showMinLabel:true
          },
          splitLine: {
            lineStyle: {
              color: "#23FA0055",
            },
          },
          min: 0,
          max: 180,
          interval: 45,
        },
        backGroundColor: "#000000",
       grid: {
          top: "10",
          bottom: "20",
          right: "5%",
          left: "50px",
        },
        series: [
          {
            data: [],
            type: "line",
            connectNulls: false,
            lineStyle: {
              color: "#23FA00",
            },
            symbol: "none",
            markLine: {
              symbol: ["none", "none"], //['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
              label: {
                position: "insideEndTop", //将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
                color: "#FF0000",
              },
              data: [
                {
                  yAxis: 160,
                  lineStyle: {
                    //警戒线的样式 ，虚实 颜色
                    type: "dashed", //样式  ‘solid’和'dotted'
                    color: "#FF0000",
                    width: 1, //宽度
                  },
                  label: {
                    formatter: "高心率阈值：{c}",
                  },
                },
                {
                  yAxis: 60,
                  lineStyle: {
                    //警戒线的样式 ，虚实 颜色
                    type: "solid", //样式  ‘solid’和'dotted'
                    color: "#FF0000",
                    width: 1, //宽度
                  },
                  label: {
                    formatter: "低心率阈值：{c}",
                  },
                },
              ],
            },
          },
        ],
      },
      spo2Options: {
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            color: "#32C3F1",
          },
          axisLine: {
            lineStyle: {
              color: "#32C3F100",
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
            interval: 0,
            lineStyle: {
              color: "#32C3F1AA",
            },
          },
        },
        yAxis: {
          type: "value",
          // name: "%",
          nameTextStyle: {
            color: "#32C3F1",
            padding: [0, 0, -5, -30], //控制y轴标题位置
          },
          axisLabel: {
            color: "#32C3F1",
            showMaxLabel:true
          },
          splitLine: {
            lineStyle: {
              color: "#32C3F155",
            },
          },
          min: 70,
          max: 100,
          interval: 10,
        },
        backGroundColor: "#000000",
        grid: {
          top: "10",
          bottom: "20",
          right: "5%",
          left: "50px",
        },
        series: [
          {
            data: [],
            connectNulls: false,
            type: "line",
            lineStyle: {
              color: "#32C3F1",
            },
            symbol: "none",
            markLine: {
              symbol: ["none", "none"], //['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
              label: {
                position: "insideEndTop", //将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
                color: "#ff0000",
                formatter: "低血氧阈值：{c}",
              },
              lineStyle: {
                //警戒线的样式 ，虚实 颜色
                type: "solid", //样式  ‘solid’和'dotted'
                color: "#ff0000",
                width: 1, //宽度
              },
              data: [
                {
                  yAxis: 90,
                },
              ],
            },
          },
        ],
      },
      chartObj: {},
      zone_number: "",
      lh: "",
      interval: "",
      interval_1: "",
      detailData: {},
      ele_total: 0,
      ele_dialog: false,
      dialogTableData: [],
      dialogTableLoading: false,
      total: 0,
      page: 1,
      tableKey: 0,
    };
  },

  mounted() {
    this.checkLogin();
    this.zone_number = this.$cookies.get("zone_number");
    this.fetchData();
    this.fetchDetailData();
    this.fetchBatNum();
    this.interval = setInterval(() => {
      this.fetchData();
      this.fetchBatNum();
    }, 600000);
    this.interval_1 = setInterval(() => {
      this.fetchDetailData();
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.interval_1);
  },
  methods: {
    fetchBatNum() {
      let data = {
        zone_number: this.zone_number,
        page: this.page,
        perPage: 5,
      };
      this.$http({
        url: "/api/hope/bat",
        method: "GET",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        this.ele_total = res.result.total;
      });
    },
    editBatStatus(item, index) {
      this.dialogTableLoading = true;
      let data = { id: item.id };
      this.$http({
        url: "/api/hope/bat_status",
        method: "POST",
        data: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        this.dialogTableLoading = false;
        this.dialogTableData[index].status = 1;
        this.$nextTick(() => {
          this.tableKey++;
        });
        this.fetchBatNum();
      });
    },
    handleCurrentChange(e) {
      this.page = e;
      let data = {
        zone_number: this.zone_number,
        page: this.page,
        perPage: 5,
      };
      this.dialogTableLoading = true;
      this.$http({
        url: "/api/hope/bat",
        method: "GET",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        this.dialogTableLoading = false;
        this.dialogTableData = res.result.data;
        this.dialogTableData.forEach((item, index) => {
          this.dialogTableData[index].status = 0;
        });
        this.total = res.result.total;
      });
    },
    openEleList() {
      this.page = 1;
      let data = {
        zone_number: this.zone_number,
        page: this.page,
        perPage: 5,
      };
      this.dialogTableLoading = true;
      this.$http({
        url: "/api/hope/bat",
        method: "GET",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        this.dialogTableLoading = false;
        this.dialogTableData = res.result.data;
        this.ele_dialog = true;
        this.total = res.result.total;
        this.dialogTableData.forEach((item, index) => {
          this.dialogTableData[index].status = 0;
        });
      });
    },
    checkLogin() {
      console.log(!this.$cookies.get("token"));
      if (!this.$cookies.get("token")) {
        this.$router.push("/login");
      }
    },
    pageTo() {
      this.$router.push({
        path: "/device_list",
        query: {
          zone_number: this.zone_number,
        },
      });
    },
    fetchDetailData() {
      this.checkLogin();
      let data = {
        zone_number: this.zone_number,
      };
      this.$http({
        url: "/api/output/getNewInfo",
        method: "POST",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        this.detailData = res.result;
      });
    },
    fetchData() {
      this.checkLogin();
      let data = {
        zone_number: this.zone_number,
        start: parseInt(new Date().getTime() / 1000) - 86400,
        end: parseInt(new Date().getTime() / 1000),
      };
      this.$http({
        url: "/api/output/signEcg",
        method: "GET",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        if (res.result && res.result.length > 0) {
          this.nodata = false;
        } else {
          this.nodata = true;
        }
        let arr = res.result;
        arr.forEach((item, index) => {
          arr[index].lastData = {};
          item.list.forEach((e, i) => {
            if (i == item.list.length - 1) {
              arr[index].lastData = e;
            }
          });
        });

        this.dataList = arr;
        this.$nextTick(() => {
          this.lh =
            document.getElementsByClassName("box_title")[0].clientHeight + "px";
          this.$nextTick(() => {
            this.dataList.forEach((item, index) => {
              this.chartObj[`data_x_${(index + 1) * 2 - 1}`] = [];
              this.chartObj[`data_x_${(index + 1) * 2}`] = [];
              this.chartObj[`data_y_${(index + 1) * 2 - 1}`] = [];
              this.chartObj[`data_y_${(index + 1) * 2}`] = [];

              item.list.forEach((e, i) => {
                if (i == item.list.length - 1) {
                  this.dataList[index].lastData = e;
                }
                this.chartObj[`data_x_${(index + 1) * 2 - 1}`].push(
                  this.$dateFtt.dateFtt("hh:00", new Date(e.insert_time * 1000))
                );
                this.chartObj[`data_x_${(index + 1) * 2}`].push(
                  this.$dateFtt.dateFtt("hh:00", new Date(e.insert_time * 1000))
                );
                this.chartObj[`data_y_${(index + 1) * 2 - 1}`].push(
                  e.heartrate
                );
                this.chartObj[`data_y_${(index + 1) * 2}`].push(e.spo2?e.spo2:0);
              });

              this.chartObj[`chartDom${(index + 1) * 2 - 1}`] =
                document.getElementById(`chart${(index + 1) * 2 - 1}`);
              this.chartObj[`myChart${(index + 1) * 2 - 1}`] = echarts.init(
                this.chartObj[`chartDom${(index + 1) * 2 - 1}`]
              );
              this.chartObj[`option${(index + 1) * 2 - 1}`] = JSON.parse(
                JSON.stringify(this.hrOptions)
              );
              this.chartObj[`option${(index + 1) * 2 - 1}`].xAxis.data =
                this.chartObj[`data_x_${(index + 1) * 2 - 1}`];
              this.chartObj[`option${(index + 1) * 2 - 1}`].series[0].data =
                this.chartObj[`data_y_${(index + 1) * 2 - 1}`];
              this.chartObj[
                `option${(index + 1) * 2 - 1}`
              ].series[0].markLine.data[0].yAxis = item.high_heartrate_value;
              this.chartObj[
                `option${(index + 1) * 2 - 1}`
              ].series[0].markLine.data[1].yAxis = item.low_heartrate_value;

              this.chartObj[`chartDom${(index + 1) * 2}`] =
                document.getElementById(`chart${(index + 1) * 2}`);
              this.chartObj[`myChart${(index + 1) * 2}`] = echarts.init(
                this.chartObj[`chartDom${(index + 1) * 2}`]
              );
              this.chartObj[`option${(index + 1) * 2}`] = JSON.parse(
                JSON.stringify(this.spo2Options)
              );
              this.chartObj[`option${(index + 1) * 2}`].xAxis.data =
                this.chartObj[`data_x_${(index + 1) * 2}`];
              this.chartObj[`option${(index + 1) * 2}`].series[0].data =
                this.chartObj[`data_y_${(index + 1) * 2}`];

              this.chartObj[
                `option${(index + 1) * 2}`
              ].series[0].markLine.data[0].yAxis = item.spo2;

              this.chartObj[`option${(index + 1) * 2 - 1}`] &&
                this.chartObj[`myChart${(index + 1) * 2 - 1}`].setOption(
                  this.chartObj[`option${(index + 1) * 2 - 1}`]
                );
              this.chartObj[`option${(index + 1) * 2}`] &&
                this.chartObj[`myChart${(index + 1) * 2}`].setOption(
                  this.chartObj[`option${(index + 1) * 2}`]
                );
            });
          });
        });
      });
    },
  },
};
</script>
<style  scoped>
.search_box {
  padding: 20px;
  position: relative;
  background-color: #f5f7fb;
}

.logo_box {
  height: 40px;
  /* width: auto; */
  position: absolute;
  right: 20px;
  top: 20px;
}

.logo_box img {
  height: 100%;
  width: auto;
  vertical-align: top;
}

.ele_btn {
  /* position: absolute; */
  margin-right: 20px;
}

.logo_box >>> .el-button--danger {
  background-color: red !important;
  border-color: red !important;
  padding-right: 50px;
  position: relative;
}

.num {
  position: absolute;
  top: 10px;
  right: 20px;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background-color: #fff;
  color: red;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
}

.container_box {
  min-height: calc(100vh - 88px);
  background-color: #000000;
  padding: 20px;
  flex-wrap: wrap;
}

.flex_item {
  width: calc(50% - 10px);
  height: calc(37vh - 88px);
  margin-bottom: 20px;
  box-shadow: 0 0 5px 1px #646464;
  border-radius: 5px;
}

.box_title {
  color: #ffffff;
  font-size: 16px;
  height: 12%;
  /* line-height: 100%; */
  padding-left: 14px;
  font-weight: bold;
  background-color: #333333;
}

.mb_20 {
  margin-bottom: 20px;
}

.flex_box {
  justify-content: space-between;
  display: flex;
  align-content: flex-start;
}

/* 
.left {
    width: 169px;
    height: 132px;
    position: relative;
}

.left img {
    width: 100%;
}

.right {
    width: calc(100% - 132px - 60px);
    height: 145px;
}

.hr_value,
.spo2_value {
    font-size: 66px;
    position: absolute;
    bottom: -5px;
    left: 5px;
    width: 100%;
}

.hr_value {
    color: #23FA00;
}

.spo2_value {
    color: #32C3F1;
}

.unit {
    font-size: 14px;
    position: absolute;
    right: 10px;
    bottom: 15px;
} */

.nodata {
  width: 30%;
  margin: auto;
}

.nodata img {
  width: 100%;
}

.data_box {
  width: 100%;

  display: flex;
}

.left {
  width: 130px;
  height: 100%;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.left > div {
  height: 50%;
  width: 100%;
  position: relative;
}

.border_bottom {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.type_title {
  /* padding: 20px; */
  font-size: 0;
  text-wrap: nowrap;
  position: absolute;
  left: 10px;
  top: 5px;
}

.type_title img {
  width: 16px;
  margin-right: 10px;
}

.type_title span {
  font-size: 16px;
  font-weight: bold;
  position: relative;
  bottom: 2px;
}

.hr_data {
  color: #23fa00;
}

.spo2_data {
  color: #32c3f1;
}

.value {
  font-size: 36px;
  text-align: center;
  font-weight: bold;
  text-align: right;
  padding-right: 20px;
  position: absolute;
  bottom: 2px;
  left: 0;
  width: 100%;
}

.unit {
  font-size: 12px;
  position: absolute;
  right: 20px;
  top: -10px;
  font-weight: 500;
}

.right {
  width: calc(100% - 130px);
}

.pagination {
  text-align: center;
}

.dialog_tips {
  font-size: 16px;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/view/managePages/all_device_data.vue